module.exports = __webpack_public_path__ + "static/media/nickdrakepic.c4c0d46d.jpg";